import { useEffect } from "react";
import styles from "./MainContainer.module.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useAtomValue, useSetAtom } from "jotai";
import { LoggedUserId, SeletectedDoctorState } from "../state/globalState";
import { getOwnerFromUser } from "../../users/hooks/useOwner";
import AppSelectorContainer from "../../centralComp/containers/AppSelectorContainer";
import { ToastContainer } from "react-toastify";
import classNames from "classnames";
import { UserLimited } from "cadendar-shared";
import {
  apiBaseUrl,
  queryClient,
  setTrpcOwner,
  trpc,
  trpcClient,
} from "./trpc.ts";

interface MainContainerProps {
  user: UserLimited | null;
}

const MainContainer = (props: MainContainerProps) => {
  const setUserId = useSetAtom(LoggedUserId);
  const selectedDoctorId = useAtomValue(SeletectedDoctorState);
  const user = props.user;
  const userId = user?.id;

  const owner = getOwnerFromUser(user, selectedDoctorId);
  setTrpcOwner(owner);
  // useEventSource(`${prefix}localhost:3005/cadendarRust/sse`, owner);
  console.log(
    "MainContainer render, owner:",
    owner,
    "user:",
    user,
    "selectedDoctorId:",
    selectedDoctorId
  );
  useEffect(() => {
    setUserId(userId || "");
  }, [userId]);
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <div className={classNames(styles.back, styles.main)}>
        <ToastContainer />
        <AppSelectorContainer />
      </div>
    </trpc.Provider>
  );
};

export default (props: MainContainerProps) => (
  <QueryClientProvider client={queryClient}>
    <MainContainer {...props} />
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
